import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { TokenInfoProvider } from "./hooks/useTokenInfo";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <TokenInfoProvider>
      <App />
    </TokenInfoProvider>
  </React.StrictMode>
);
